module.exports = __webpack_public_path__ + "static/media/sample.2c8713b0.xlsx";